import React from "react";
import PropTypes from "prop-types";

class LoadingIndicator extends React.Component {
  static propTypes = {
    type: PropTypes.string,
    loadingText: PropTypes.string
  };
  static defaultProps = {
    type: null,
    loadingText: null
  };

  constructor(props) {
    super(props);
    this.state = {
      progress: 0
    };
  }

  render() {
    switch (this.props.type) {
      case "three-bounce":
        return /*#__PURE__*/React.createElement("div", {
          className: "three-bounce"
        }, /*#__PURE__*/React.createElement("div", {
          className: "bounce1"
        }), /*#__PURE__*/React.createElement("div", {
          className: "bounce2"
        }), /*#__PURE__*/React.createElement("div", {
          className: "bounce3"
        }));
        break;

      case "circle":
        return /*#__PURE__*/React.createElement("div", {
          className: "circle-wrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "circle1 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle2 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle3 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle4 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle5 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle6 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle7 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle8 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle9 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle10 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle11 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle12 circle"
        }));
        break;

      case "circle-small":
        return /*#__PURE__*/React.createElement("div", {
          className: "circle-wrapper",
          style: {
            height: "15px",
            minHeight: "15px"
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "circle1 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle2 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle3 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle4 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle5 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle6 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle7 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle8 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle9 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle10 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle11 circle"
        }), /*#__PURE__*/React.createElement("div", {
          className: "circle12 circle"
        }));
        break;

      default:
        var classes = "loading-overlay";

        if (this.progress > 0) {
          classes += " with-progress";
        }

        return /*#__PURE__*/React.createElement("div", {
          className: classes
        }, /*#__PURE__*/React.createElement("div", {
          className: "loading-panel"
        }, this.props.loadingText && /*#__PURE__*/React.createElement("div", {
          className: "text-center",
          style: {
            paddingTop: "10px",
            color: "black"
          }
        }, this.props.loadingText), /*#__PURE__*/React.createElement("div", {
          className: "spinner"
        }, /*#__PURE__*/React.createElement("div", {
          className: "bounce1"
        }), /*#__PURE__*/React.createElement("div", {
          className: "bounce2"
        }), /*#__PURE__*/React.createElement("div", {
          className: "bounce3"
        })), /*#__PURE__*/React.createElement("div", {
          className: "progress-indicator"
        }, /*#__PURE__*/React.createElement("span", null, this.state.progress))), !!this.props.children && /*#__PURE__*/React.createElement("div", {
          className: "loading-panel--child"
        }, this.props.children));
    }
  }

}

export default LoadingIndicator;